import { CSSProperties } from 'react';
import { Icon } from '~/commonComponents';
import ConfirmPopup from '~/components/shared/ConfirmPopup';

// Standard spacing between a warning icon and the popup title in ConfirmPopup.
// ConfirmPopup renders Icon → h1 with no built-in gap; marginTop on the title bridges it.
const POPUP_ICON_TITLE_GAP: CSSProperties = { marginTop: 20 };

interface IWizardNavigationGuardProps {
  isOpen: boolean;
  /** Called when the user clicks "Go Back" or the close (×) icon — clears pending nav and hides the popup. */
  onStay: () => void;
  /** Called when the user clicks "Leave Anyway" — navigates to the pending destination. */
  onLeave: () => void;
}

/**
 * Shared navigation guard popup for the Post Shifts wizard.
 * Shown when the user attempts to navigate away mid-flow.
 * Renders nothing when `isOpen` is false.
 */
export const WizardNavigationGuard = ({ isOpen, onStay, onLeave }: IWizardNavigationGuardProps) => {
  if (!isOpen) return null;

  return (
    // @ts-expect-error -- ConfirmPopup still written in JavaScript
    <ConfirmPopup
      Icon={() => <Icon name="warning-outline" size={80} />}
      titleStyle={POPUP_ICON_TITLE_GAP}
      title="Are You Sure You Want to Leave?"
      description="Your shifts haven't been posted yet. Leaving now means the progress made to your request won't be saved."
      leftButtonText="Go Back"
      leftButtonAction={onStay}
      rightButtonText="Leave Anyway"
      rightButtonAction={onLeave}
      closePopup={onStay}
      dataTestId="navigation-guard-popup"
    />
  );
};
